// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bEeC","right":"styles_right__n1Tpq"};